import { useState, useRef, useEffect } from 'react';
import { Pencil } from 'lucide-react';
import EditSelectOptionsModal from '../EditSelectOptionsModal';

function normalizeOptions(config) {
  const raw = Array.isArray(config?.options) ? config.options : [];
  return raw.map((o) => (typeof o === 'string' ? { label: o, color: '#c4c4c4' } : o));
}

export default function SelectCell({ value, column, config, onChange, readOnly = false }) {
  const [open, setOpen] = useState(false);
  const [editorOpen, setEditorOpen] = useState(false);
  const ref = useRef(null);
  const options = normalizeOptions(config || column?.config);
  const safeValue = value == null || typeof value === 'object' ? null : value;
  const selected = options.find((o) => o.label === safeValue);

  useEffect(() => {
    if (!open) return;
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [open]);

  const handleSelect = (opt) => { onChange(opt.label); setOpen(false); };
  const handleClear = () => { onChange(null); setOpen(false); };

  return (
    <div ref={ref} className="relative w-full h-full">
      <button
        onClick={() => setOpen(!open)}
        disabled={readOnly}
        className="w-full h-full flex items-center justify-center px-2 py-1 transition-colors min-h-[40px] disabled:cursor-default"
        style={selected ? { backgroundColor: selected.color, color: '#fff' } : undefined}
      >
        {selected ? (
          <span className="cell-badge-text font-semibold truncate">{selected.label}</span>
        ) : safeValue ? (
          <span className="text-sm text-text-primary truncate">{safeValue}</span>
        ) : (
          <span />
        )}
      </button>

      {open && !readOnly && (
        <div className="absolute top-full left-0 z-50 mt-1 w-56 bg-card border border-border rounded-lg shadow-xl py-2 overflow-hidden">
          <div className="grid grid-cols-2 gap-1.5 px-2 pb-2">
            {options.map((opt, i) => (
              <button
                key={i}
                onClick={() => handleSelect(opt)}
                className="rounded px-2 py-1.5 text-[11px] font-semibold text-white hover:opacity-90 transition-opacity truncate"
                style={{ backgroundColor: opt.color }}
                title={opt.label}
              >
                {opt.label}
              </button>
            ))}
            <button
              onClick={handleClear}
              className="rounded px-2 py-1.5 text-[11px] font-semibold text-text-secondary bg-white/5 hover:bg-white/10 transition-colors"
            >
              —
            </button>
          </div>
          <div className="border-t border-border/50 pt-1">
            <button
              onClick={() => { setOpen(false); setEditorOpen(true); }}
              className="w-full flex items-center gap-2 px-3 py-2 text-xs text-text-primary hover:bg-white/5 transition-colors"
            >
              <Pencil className="w-3.5 h-3.5" />
              Editar opções
            </button>
          </div>
        </div>
      )}

      {editorOpen && column && (
        <EditSelectOptionsModal
          column={column}
          onClose={() => setEditorOpen(false)}
        />
      )}
    </div>
  );
}
